<template>
  <div id="app">
    <router-view/>
  </div>

</template>

<script>
import eventBus from './eventBus';

export default {
  name: 'App',
  created() {
    eventBus.$on('permission-denied', this.showPermissionDeniedToast);
  },
  beforeDestroy() {
    eventBus.$off('permission-denied', this.showPermissionDeniedToast);
  },
  methods: {
    showPermissionDeniedToast() {
      this.makeToast('Permission Denied', 'You dont have permission to perform this action. Please contact your senior for further assistance.', 'danger');
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
background-color: #707070;
}

</style>
